import React, { useState } from "react";
import { GenericDialog } from "../../../components/generic/GenericDialog";
import { Box, Button, Stack, Typography } from "@mui/material";
import { GenericCircleIcon } from "../../../components/generic/GenericCircleIcon";
import { Trash } from "@phosphor-icons/react";
import LoadingButton from "@mui/lab/LoadingButton";
import { deleteTag } from "../../../config/apisauce";
import useNotiStack from "../../../hooks/useNotiStack";
import { DELETED } from "../../../enums/statusEnums";

export const DeleteCategoryDialog = ({ selectedTag, openDeleteDialog, alterList, handleClose }) => {
  const { success } = useNotiStack();
  const [deleteLoader, setDeleteLoader] = useState(false);

  const handleDeleteTag = async () => {
    setDeleteLoader(true);
    const response = await deleteTag({ id: selectedTag?.id, name: selectedTag?.name, status: DELETED });
    if (response.ok) {
      success('Successfully deleted!');
      handleClose();
      alterList((prev) => {
        const currentList = { ...prev };
        currentList.data = currentList?.data?.filter((item) => item?.id !== response?.data?.id);
        return currentList;
      })
    };
    setDeleteLoader(false);
  };

  return (
    <GenericDialog
      title={'Delete'}
      width={'500px'}
      openDialog={openDeleteDialog}
      handleClose={() => handleClose()}
    >
      <Box display={'flex'} justifyContent={'center'} alignItems={'center'} mb={2}>
        <GenericCircleIcon color={'primary.main'}>
          <Trash size={96} weight="thin" />
        </GenericCircleIcon>
      </Box>
      <Typography variant="subtitle1" textAlign={'center'}>
        This action cannot be undone.<br></br>Are you sure you want to continue?
      </Typography>
      <Stack gap={1} alignItems={'center'} mt={3}>
        <LoadingButton
          onClick={() => handleDeleteTag()}
          loading={deleteLoader}
          variant="contained"
          color="error"
          disabled={deleteLoader}
          sx={{ width: { xs: '100%', sm: '250px' } }}
        >
          Delete
        </LoadingButton>
        <Button variant="outlined" sx={{ width: { xs: '100%', sm: '250px' } }} onClick={() => handleClose()}>Cancel</Button>
      </Stack>
    </GenericDialog>
  )
};